import { mapState } from 'pinia';
import stores from 'store/modules';
import qs from 'qs';
import { cloneDeep, isEqual, debounce } from 'lodash';
import { v4 as uuidv4 } from 'uuid';

const isEmptyValue = (item) =>
    Boolean(
        item.operator === 'is_known' ||
            item.operator === 'is_unknown' ||
            item.operator === 'last_week' ||
            item.operator === 'last_month'
    );

export default {
    data: () => ({
        filtersList: [],
        filtersListSave: false,
        filtersListGroups: {
            tags: [],
            segments: [],
            contacts: [],
            advanced: [],
        },
        filtersListGroupsSave: false,
    }),

    computed: {
        showSegments() {
            return (
                !this.disableSegments &&
                !this.hasNewSegment &&
                !this.filterSelected &&
                !this.chooseFilter &&
                this.filterSegmentsCount
            );
        },

        filterSegmentsCount() {
            return this.filterSegments.length;
        },

        filterClasses() {
            return {
                filter__show: this.show,
                filter__choose: Boolean(this.chooseFilter),
                loadingState: this.loadingFilters,
                'disabled-element': this.disabled,
            };
        },

        filterCount() {
            let countFilters = 0;

            this.filtersList.forEach((filters) => {
                countFilters += filters.length;
            });

            return countFilters;
        },

        filterCountGroups() {
            let countFilters = 0;

            for (let key in this.filtersListGroups) {
                countFilters += this.filtersListGroups[key].length;
            }

            return countFilters;
        },

        filterSelected() {
            let countFilters = 0;

            this.filtersList.forEach((filters) => {
                countFilters += filters.filter((item) => {
                    if (Array.isArray(item.value)) {
                        if (item.type === 'tags') {
                            item.value.forEach((o) => {
                                this.emptyTagsArr = o.length === 0;
                            });
                        }
                        return item.value.length;
                    }

                    return item.value || isEmptyValue(item);
                }).length;
            });

            return this.emptyTagsArr ? 0 : countFilters;
        },

        filtersValues() {
            let emtyField = true;
            this.filtersList.map((filters) => {
                filters.map((e) => {
                    if (Array.isArray(e.value)) {
                        if (emtyField && !e.value.length) {
                            emtyField = false;
                        }
                    } else if (typeof e.value === 'object') {
                        if (emtyField && !e.value) {
                            emtyField = false;
                        }
                    } else {
                        if (emtyField && !e.value.trim()) {
                            emtyField = false;
                        }
                    }
                });
            });

            return emtyField;
        },

        paramsListGroupsFilter() {
            return this.filtersListGroups;
        },

        paramsListFilter() {
            const filtersList = this.filtersList.map((filters) => {
                filters = filters
                    .map((item) => {
                        if (this.filtersData.operators) {
                            const operators = this.filtersData.operators[item.type];
                            const operator = operators
                                ? operators.find((e) => e.key === item.operator)
                                : null;
                            const isAllowEmptyCheckbox = operator
                                ? operator.allow_empty_checkbox
                                : false;
                            const data = {
                                key: item.name,
                                operator: item.operator,
                                value: item.value,
                            };

                            if (isAllowEmptyCheckbox) {
                                data.is_empty = Number(Boolean(item.is_empty));
                            }

                            if (item.filterType === 'custom_field') {
                                data.type = item.type;

                                return data;
                            }

                            return data;
                        }
                    })
                    .filter((item) => {
                        if (Array.isArray(item.value)) {
                            return item.value.length;
                        }

                        if (isEmptyValue(item)) {
                            return true;
                        }

                        return item.value;
                    });

                // Simple Params
                let simpleFilters = filters
                    .filter(
                        (item) =>
                            item.key !== 'filter_tags' && item.key !== 'integrations' && !item.type
                    )
                    .map((item) => {
                        if (item.operator === 'is_between' || item.operator === 'is_not_between') {
                            const params = {
                                ...item,
                                ...item.value,
                            };

                            delete params.value;

                            return params;
                        }

                        return item;
                    });

                // Tags Params
                const tagsFilters = filters
                    .filter((item) => item.key === 'filter_tags' && !item.type)
                    .map((item) => {
                        return {
                            operator: item.operator,
                            value: Array.isArray(item.value)
                                ? item.value.map((i) => i.map((o) => o.name))
                                : [],
                        };
                    });
                const tagsFiltersEqual = tagsFilters
                    .filter((item) => item.operator === 'equals')
                    .map((item) => item.value)
                    .reduce((state, currentItem) => [...state, ...currentItem], [])
                    .reduce(
                        (state, currentItem) =>
                            state.includes(currentItem) ? state : [...state, currentItem],
                        []
                    );
                const tagsFiltersNotEqual = tagsFilters
                    .filter((item) => item.operator === 'not_equal')
                    .map((item) => item.value)
                    .reduce((state, currentItem) => [...state, ...currentItem], [])
                    .reduce(
                        (state, currentItem) =>
                            state.includes(currentItem) ? state : [...state, currentItem],
                        []
                    );
                const tagsFiltersObject = {};

                if (tagsFiltersEqual[1] === undefined) {
                    tagsFiltersEqual.splice(1, 1);
                }

                if (tagsFiltersNotEqual[1] === undefined) {
                    tagsFiltersNotEqual.splice(1, 1);
                }

                if (tagsFiltersEqual.length) tagsFiltersObject['equals'] = tagsFiltersEqual;
                if (tagsFiltersNotEqual.length)
                    tagsFiltersObject['not_equal'] = tagsFiltersNotEqual;

                // Custom Fields Params
                const customFieldFilters = filters
                    .filter((item) => item.type)
                    .map((item) => {
                        if (item.operator === 'is_between' || item.operator === 'is_not_between') {
                            const params = {
                                ...item,
                                ...item.value,
                            };

                            delete params.value;

                            return params;
                        }

                        return item;
                    });

                // Integration List Params
                let integrationListFilters = filters
                    .filter((item) => item.key === 'integrations')
                    .map((item) => ({
                        integration_key: 'hubspot',
                        list_id: item.value,
                    }));

                return {
                    filters: simpleFilters,
                    filter_tags: tagsFiltersObject,
                    custom_filters: customFieldFilters,
                    integration_lists: integrationListFilters,
                };
            });

            return filtersList;
        },

        isFilterEmpty() {
            let countFilters = 0;

            this.filtersList.forEach((filters) => {
                countFilters += filters.filter((item) => item.value || isEmptyValue(item)).length;
            });

            return !countFilters;
        },

        customFilters() {
            if (!this.filtersData.custom_filters) {
                return [];
            }

            return this.filtersData.custom_filters;
        },

        isContactOrBroadcastsPage() {
            return Boolean(this.name === 'contacts' || this.name === 'broadcasts');
        },

        hasLoadedHubSpotContactLists() {
            return Boolean(this.loadedHubSpotContactLists.length);
        },

        ...mapState(stores.FilterSegment, ['filterSegments']),
    },

    watch: {
        filterCount() {
            this.filtersList = this.filtersList.filter((filters) => filters.length);
        },

        paramsListGroupsFilter(newFilters, oldFilters) {
            newFilters = JSON.stringify(newFilters);
            oldFilters = JSON.stringify(oldFilters);

            if (newFilters !== oldFilters) {
                this.$emit('changeCountFilters', this.filterCountGroups);

                if (this.filterCountGroups) {
                    this.debounceHandleFiltersApply(true);
                }
            }
        },

        paramsListFilter(newFilters, oldFilters) {
            newFilters = JSON.stringify(newFilters);
            oldFilters = JSON.stringify(oldFilters);

            if (!oldFilters.length || (newFilters !== oldFilters && !this.isFilterEmpty)) {
                this.debounceHandleFiltersApply();
            }
        },

        chooseFilter(value) {
            this.typeSegment = value ? 'edit' : 'create';
        },

        filterSelected(length) {
            this.$emit('changeCountFilters', length);
            this.updateQuery();

            if (this.show && this.filterSelected && !this.chooseFilter) {
                this.hasNewSegment = true;
            }
        },

        show(value) {
            if (this.chooseFilter) {
                this.initFilterList(this.chooseFilter.filters);
            } else {
                if (value && !this.filterCount) {
                    this.filtersList.push(this.defaultListFilter());
                }
            }
        },
    },

    methods: {
        async load() {
            this.debounceHandleFiltersApply = debounce(this.handleFiltersApply, 500);
            this.loading = true;

            try {
                if (!this.filtersData && !this.loadingFilters) {
                    this.loadingFilters = true;
                    await this.initFiltersData();
                    this.loadingFilters = false;
                }
                this.filtersList.push(this.defaultListFilter());

                await this.initCustomFieldsFilters();
                // await this.$store.dispatch('getHubspotListsContact');
                await this.$store.dispatch('getHubspotListsContactProcessed');

                if (
                    this.isContactOrBroadcastsPage &&
                    this.hasLoadedHubSpotContactLists &&
                    this.hasHubSpotIntegration
                ) {
                    await this.initIntegrationsFilters();
                }

                await this.initQuery();

                this.$emit('filterLoaded', {
                    filter: this,
                });
            } finally {
                this.loading = false;
            }
        },

        async initFiltersData() {
            this.filtersData = cloneDeep(await this.$store.dispatch(`${this.name}Filters`));
            this.filtersData.filters = this.filtersData.filters.map((item) => ({
                ...item,
                class: item.category || 'contact_fields',
            }));
        },

        async initQuery() {
            if (!this.hasQuery) return;

            const segment_id = +this.$route.query.segment_id;

            if (segment_id) {
                const filterSegment = this.filterSegments.find((item) => item.id === segment_id);

                if (filterSegment) {
                    this.chooseFilter = filterSegment;
                    this.handleInitSegmentFilter();
                }
            } else {
                if (this.$route.query.filters) {
                    const filters = qs.parse(this.$route.query.filters);

                    this.initFilterList(filters);
                }
            }
        },

        updateQuery() {
            if (!this.hasQuery) return;

            if (this.chooseFilter) {
                this.$router.push({
                    query: {
                        segment_id: this.chooseFilter.id,
                    },
                });
            } else {
                this.$router.push({
                    query: {
                        filters: qs.stringify({
                            filtersList: this.paramsListFilter,
                        }),
                        segment_id: 0,
                    },
                });
            }
        },

        async handleFiltersApply(groupsStatus = false) {
            this.$emit('handleChangeFilters', {
                filter: this,
                groupsStatus: groupsStatus,
            });
        },

        initCustomFieldsFilters() {
            if (this.customFilters) {
                const customFilters = [];

                this.customFilters.forEach((item) => {
                    let type = 'text';

                    if (item.type === 'date' || item.type === 'number' || item.type === 'url') {
                        type = item.type;
                    }

                    customFilters.push({
                        key: item.key,
                        name: item.name,
                        type: type,
                        filterType: 'custom_field',
                        class: 'custom_fields',
                    });
                });

                this.filtersData.filters = this.filtersData.filters.concat(customFilters);
            }
        },

        async initIntegrationsFilters() {
            const itemFilter = [
                {
                    key: 'integrations',
                    name: 'HubSpot Lists',
                    type: 'integrations_hubspot',
                    filterType: 'integrations_hubspot',
                    class: 'integrations',
                },
            ];

            this.filtersData.filters = this.filtersData.filters.concat(itemFilter);
        },

        async initFilterListGroups(filtersList) {
            const hasFiltersList = Boolean(
                typeof filtersList === 'object' && filtersList.filtersList
            );
            const hasFiltersListGroups = Boolean(
                typeof filtersList === 'object' && filtersList.filtersListGroups
            );
            const hasFiltersListSegment = Boolean(typeof filtersList === 'number');

            if (hasFiltersList) {
                this.filtersListGroups = {
                    tags: [],
                    segments: [],
                    contacts: [],
                    advanced: [
                        {
                            filtersList: filtersList.filtersList,
                        },
                    ],
                };
            }

            if (hasFiltersListSegment) {
                this.filtersListGroups = {
                    tags: [],
                    segments: [filtersList],
                    contacts: [],
                    advanced: [],
                };
            }

            if (hasFiltersListGroups) {
                this.filtersListGroups = filtersList.filtersListGroups;
            }

            this.filtersListGroupsSave = cloneDeep(this.filtersListGroups);
        },

        async initFilterList(filtersList, tags) {
            if (!tags) tags = this.tags;

            if (typeof filtersList === 'object' && filtersList.filtersList) {
                filtersList = filtersList.filtersList;
            }

            if (typeof filtersList === 'number') {
                this.chooseFilter = this.filterSegments.find((item) => item.id === filtersList);

                if (!this.chooseFilter) return;

                if (this.chooseFilter.filters.filtersList) {
                    filtersList = this.chooseFilter.filters.filtersList;
                } else {
                    filtersList = this.chooseFilter.filters;
                }
            }

            if (!Array.isArray(filtersList)) {
                const filtersAll = await this.initFilter(filtersList, tags);

                this.filtersList = [filtersAll];
            } else {
                let filtersListAll = [];

                for (let i = 0; i < filtersList.length; i++) {
                    let filters = filtersList[i];
                    let filtersAll = await this.initFilter(filters, tags);

                    filtersListAll.push(filtersAll);
                }

                this.filtersList = filtersListAll;
            }

            if (this.filterSelected && !this.chooseFilter) {
                this.filtersListSave = cloneDeep(this.filtersList);
            }
        },

        async initFilter(filters, tags) {
            if (!filters.filters) filters.filters = [];
            if (!filters.custom_filters) filters.custom_filters = [];
            if (!filters.filter_tags) filters.filter_tags = {};
            if (!filters.integration_lists) filters.integration_lists = [];

            let filtersAll = [...filters.filters, ...filters.custom_filters];

            if (filters.integration_lists.length) {
                filters.integration_lists.forEach((item) => {
                    filtersAll.push({
                        key: 'integrations',
                        operator: '',
                        type: 'integrations_hubspot',
                        value: item.list_id,
                    });
                });
            }

            if (
                this.hasTag &&
                (filters.filter_tags['equals'] || filters.filter_tags['not_equal'])
            ) {
                for (let operator in filters.filter_tags) {
                    const value = filters.filter_tags[operator]
                        .map((nameArr) => {
                            nameArr = Array.isArray(nameArr) ? nameArr : [nameArr];

                            return nameArr
                                .map((name) => {
                                    const exist = tags.find((e) => e.name === name);

                                    if (!exist) return;

                                    return {
                                        id: exist.id,
                                        name: exist.name,
                                    };
                                })
                                .filter((item) => item);
                        })
                        .filter((item) => item);

                    filtersAll.push({
                        key: 'filter_tags',
                        operator: operator,
                        is_empty: false,
                        value: value,
                    });
                }
            }

            if (!this.filtersData) {
                await this.initFiltersData();
            }

            if (
                this.filtersData &&
                !this.filtersData.filters.find((item) => item.key === 'integrations')
            ) {
                this.initIntegrationsFilters();
            }

            filtersAll = filtersAll.map((item, i) => {
                const filter = this.filtersData.filters.find((i) => i.key === item.key);
                const isBetween =
                    item.operator === 'is_between' || item.operator === 'is_not_between';
                const value = isBetween ? { from: item.from, to: item.to } : item.value;

                if (!filter) return;
                if (item.key === 'integrations') {
                    return {
                        key: uuidv4(),
                        name: item.key,
                        type: item.type,
                        value: value,
                    };
                }

                if (item.type) {
                    return {
                        key: uuidv4(),
                        name: item.key,
                        operator: item.operator,
                        type: item.type,
                        is_empty: Boolean(Number(item.is_empty)),
                        value: value,
                        filterType: 'custom_field',
                    };
                }

                return {
                    key: uuidv4(),
                    name: item.key,
                    operator: item.operator,
                    type: filter ? filter.type : 'tags',
                    is_empty: Boolean(Number(item.is_empty)),
                    value: value,
                };
            });

            filtersAll = filtersAll.filter((filter) => {
                if (!filter) return false;
                if (filter.name === 'filter_tags') {
                    return Array.isArray(filter.value) && filter.value.length;
                }

                return filter.value;
            });

            return filtersAll;
        },

        changeValueFilter({ filter, update = false } = {}) {
            this.updateQuery();

            if (this.hasModal && this.chooseFilter) {
                if (!isEqual(this.chooseFilter.filters, this.paramsListFilter)) {
                    this.chooseFilter = null;
                    this.initFilterList(this.paramsListFilter);
                }
            }

            if ((this.hasCheckPreview && filter.value) || update) {
                this.applyFilter(false, 'update_value');
            }
        },

        handleClick(e) {
            if (this.loadingFilters) return;
            this.show = !this.show;

            if (this.show && this.filterSelected && !this.chooseFilter) {
                this.hasNewSegment = true;
            }
        },

        handleEditCheck() {
            if (this.edit) {
                this.clear({ status: true });
            }
        },

        handleHasNewSegmentCheck() {
            if (this.hasNewSegment && !this.filtersListSave) {
                this.clear({ status: true });
            }
        },

        handleChangeStatusModal(status = true, isFirstFilterIntegration = false) {
            isFirstFilterIntegration = this.isFirstFilterIntegration;
            this.$emit('handleIsFirstFilterIntegration', isFirstFilterIntegration);

            this.handleEditCheck();
            this.handleHasNewSegmentCheck();
            this.show = status;
            this.edit = false;
            this.hasNewSegment = false;

            if (this.filtersListSave) {
                this.filtersList = cloneDeep(this.filtersListSave);
            }
        },

        async clear({ e, status = true }) {
            e && e.preventDefault();

            if (this.name === 'contacts') {
                this.debounceHandleFiltersApply();
            }

            this.$emit('clearIsFirstFilterIntegration');
            this.$emit('clearTotalContactsToBroadcast', 0);
            this.filtersList.splice(1, this.filtersList.length - 1);
            this.filtersList.forEach((filters, i) => {
                filters.forEach((item) => {
                    item.type = 'text';

                    if (item.form) {
                        item.form.name = item.name = 'first_name';
                        item.form.operator = item.operator = 'equals';
                        item.is_empty = false;
                        item.form.value = item.value = '';

                        if (this.hasTag) {
                            item.form.tags = [];
                        }
                    } else {
                        item.name = 'first_name';
                        item.operator = 'equals';
                        item.is_empty = false;
                        item.value = '';
                    }
                });

                if (status) {
                    if (i === 0) {
                        filters.splice(1, filters.length - 1);
                    }
                }
            });

            if (
                this.name === 'triggers' ||
                this.name === 'broadcastsPage' ||
                this.name === 'recurringBroadcastsPage'
            ) {
                this.filtersList.splice(0);
                this.$store.dispatch(`${this.name}FiltersApply`, this.filtersList);
            }

            try {
                this.edit = false;
                this.filtersListSave = false;
                this.show = false;
                this.chooseFilter = null;
                this.hasNewSegment = false;
                this.updateQuery();
            } catch (e) {
                this.$log.error(e, this.$options.__file, 'clear');
            }
        },

        removeFilter({ key, filters }) {
            const index = filters.findIndex((item) => item.key === key);
            filters.splice(index, 1);

            if (this.hasCheckPreview) {
                this.applyFilter(false, 'remove');
            }
        },

        defaultListFilter() {
            return [this.defaultFilter()];
        },

        addFilter({ filters }) {
            filters.push(this.defaultFilter());
        },

        addList() {
            this.filtersList.push(this.defaultListFilter());
        },

        async applyFilter(hasShow = true, type = 'submit') {
            this.loadingSend = true;
            this.edit = false;

            if (!this.hasCheckPreview) {
                this.hasNewSegment = false;
            }

            if (type === 'submit') {
                this.filtersListSave = cloneDeep(this.filtersList);
            }

            if (this.form) {
                if (this.chooseFilter) {
                    this.form.segment_id = this.chooseFilter.id;
                    this.form.filters = {};
                } else {
                    this.form.segment_id = null;
                    this.form.filters.filtersList = this.paramsListFilter;
                }

                return;
            }

            this.loadingSend = false;

            if (hasShow) {
                this.show = false;
            }
        },

        handleOutSideHide(e) {
            if (
                !this.$el.contains(e.target) &&
                e.target.tagName !== 'BODY' &&
                e.target.className !== 'remove'
            ) {
                this.show = false;
            }
        },

        handleNewSegment(status = true) {
            this.hasNewSegment = status;
        },

        handleChangeTypeSegment(type = 'create') {
            this.typeSegment = type;
        },

        handleOpenSaveSegmentModal(status = true) {
            this.showSegmentModal = status;
        },

        async handleSaveSegment(form) {
            form.busy = true;

            try {
                const segmentFilter = await this.$store.dispatch(
                    'createOrganizationSegmentsCreate',
                    {
                        name: form.name,
                        filters: this.paramsListFilter,
                    }
                );

                this.chooseFilter = segmentFilter;
                this.updateQuery();
            } catch (e) {
                this.$log.error(e, this.$options.__file, 'handleSaveSegment');
            } finally {
                form.busy = false;
                this.handleOpenSaveSegmentModal(false);
            }
        },

        async handleUpdateSegment(form) {
            form.busy = true;

            try {
                const segmentFilter = await this.$store.dispatch(
                    'updateOrganizationSegmentsByIdUpdate',
                    {
                        id: this.chooseFilter.id,
                        name: form.name,
                        filters: this.paramsListFilter,
                    }
                );

                this.chooseFilter = segmentFilter;
                this.applyFilter(false, 'update_segment');
                this.updateQuery();
            } catch (e) {
                this.$log.error(e, this.$options.__file, 'handleUpdateSegment');
            } finally {
                form.busy = false;
                this.handleOpenSaveSegmentModal(false);
            }
        },

        async handleDeleteSegment(form) {
            form.busy = true;

            try {
                await this.$store.dispatch(
                    'deleteOrganizationSegmentsByIdDelete',
                    this.chooseFilter.id
                );

                this.chooseFilter = null;
                this.clear({ status: true });
            } catch (e) {
                this.$log.error(e, this.$options.__file, 'handleDeleteSegment');
            } finally {
                form.busy = false;
                this.handleOpenSaveSegmentModal(false);
            }
        },

        handleChooseSegmentFilter(filterSegment) {
            this.chooseFilter = filterSegment;
            this.handleInitSegmentFilter();

            if (this.hasModal) {
                this.show = false;
            }
        },

        handleUpdateSegmentFilter(filterSegment) {
            this.chooseFilter = filterSegment;
            this.handleInitSegmentFilter();
            this.edit = true;
        },

        handleClearSegmentFilter(e) {
            if (e) {
                e.stopPropagation();
            }

            this.chooseFilter = null;
            this.clear({ status: true });
        },

        handleInitSegmentFilter() {
            this.initFilterList(this.chooseFilter.filters);
            this.applyFilter(false, 'init_segment');
        },

        handleChangeLoadingSend(status = true) {
            this.loadingSend = status;
        },

        defaultFilter() {
            let name = 'first_name';

            if (this.name === 'triggers') {
                return {
                    key: uuidv4(),
                    name: 'workflows.is_active',
                    operator: 'is_any',
                    type: 'select_without_checkbox',
                    is_empty: false,
                    value: '',
                };
            }

            if (this.name === 'broadcastsPage') {
                return {
                    key: uuidv4(),
                    name: 'broadcasts.status',
                    operator: 'is_any',
                    type: 'select_without_checkbox',
                    is_empty: false,
                    value: '',
                };
            }

            if (this.name === 'recurringBroadcastsPage') {
                return {
                    key: uuidv4(),
                    name: 'broadcasts.created_at',
                    operator: 'is_equal_to',
                    type: 'date_without_checkbox',
                    is_empty: false,
                    value: '',
                };
            }

            if (this.name === 'contacts') {
                return {
                    key: uuidv4(),
                    name: 'first_name',
                    operator: 'equals',
                    type: 'text',
                    is_empty: false,
                    value: '',
                };
            }

            if (
                this.name === 'broadcasts' &&
                this.filtersList[0] &&
                this.filtersList[0][0].name === 'integrations'
            ) {
                name = 'integrations';
            }

            return {
                key: uuidv4(),
                name: name,
                operator: 'equals',
                type: 'text',
                is_empty: false,
                value: '',
            };
        },

        handleClearFilters(filtersIndex, filterIndex) {
            this.filtersList = this.filtersList
                .map((item, i) => {
                    if (filtersIndex === i) {
                        item = item.filter((filter, idx) => filterIndex === idx);
                        return item;
                    }
                    return null;
                })
                .filter((item) => item);
        },

        handleIsFirstFilterIntegration(status) {
            this.$emit('handleIsFirstFilterIntegration', status);
        },
    },
};
